module.exports = __webpack_public_path__ + "img/scream_cat.efc3affc.png";